<template>

  <div>

    <add-new
      :is-add-new-user-sidebar-active.sync="isAddNewUserSidebarActive"
      :role-options="roleOptions"
      :user-data="userData"
      @refetch-data="refetchData"
      @refresh-detail="refreshDetail"
    />

    <!-- Filters -->
    <!-- <list-filters
      :role-filter.sync="roleFilter"
      :role-options="roleOptions"
    /> -->

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <b-button
                variant="primary"
                @click="AddData()"
              >
                <span class="text-nowrap">Add Data</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="fetchData"
        responsive
        :fields="tableColumns"
        :busy.sync="isBusy"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
        striped
      >
        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-button
              variant="outline-primary"
              disabled
              class="mr-1"
            >
              <b-spinner small />
              Loading...
            </b-button>
          </div>
        </template>
        <!-- Column: Actions -->
        <template
          #cell(member)="data"
          :style="{ width: '180px' }"
        >
          <b-card>
            <b-row style="width: max-content">
              <b-col
                v-if="productsOnSale(data.item.id_tag).length > 0"
                class="text-nowrap"
              >
                <p
                  v-for="(detail, i) in productsOnSale(data.item.id_tag)"
                  v-if="detail.id_tag === data.item.id_tag && i < 5"
                  :key="i"
                >
                  <feather-icon
                    v-if="detail.operand === 'tambah'"
                    icon="PlusIcon"
                    class="cursor-pointer"
                    :class="`text-success`"
                    size="15"
                  />
                  <feather-icon
                    v-if="detail.operand === 'kurang'"
                    icon="MinusIcon"
                    class="cursor-pointer"
                    :class="`text-danger`"
                    size="15"
                  /> {{ detail.device_name }}
                </p>
              </b-col>

              <b-col
                v-if="productsOnSale(data.item.id_tag).length > 5"
                class="text-nowrap"
              >
                <p
                  v-for="(detail, i) in productsOnSale(data.item.id_tag)"
                  v-if="detail.id_tag === data.item.id_tag && i > 4 && i < 10"
                  :key="i"
                >
                  <feather-icon
                    v-if="detail.operand === 'tambah'"
                    icon="PlusIcon"
                    class="cursor-pointer"
                    :class="`text-success`"
                    size="15"
                  />
                  <feather-icon
                    v-if="detail.operand === 'kurang'"
                    icon="MinusIcon"
                    class="cursor-pointer"
                    :class="`text-danger`"
                    size="15"
                  /> {{ detail.device_name }}
                </p>
              </b-col>

              <b-col
                v-if="productsOnSale(data.item.id_tag).length > 10"
                class="text-nowrap"
              >
                <p
                  v-for="(detail, i) in productsOnSale(data.item.id_tag)"
                  v-if="detail.id_tag === data.item.id_tag && i > 9 && i <15"
                  :key="i"
                >
                  <feather-icon
                    v-if="detail.operand === 'tambah'"
                    icon="PlusIcon"
                    class="cursor-pointer"
                    :class="`text-success`"
                    size="15"
                  />
                  <feather-icon
                    v-if="detail.operand === 'kurang'"
                    icon="MinusIcon"
                    class="cursor-pointer"
                    :class="`text-danger`"
                    size="15"
                  /> {{ detail.device_name }}
                </p>
              </b-col>

              <b-col
                v-if="productsOnSale(data.item.id_tag).length > 15"
                class="text-nowrap"
              >
                <p
                  v-for="(detail, i) in productsOnSale(data.item.id_tag)"
                  v-if="detail.id_tag === data.item.id_tag && i > 14 && i <20"
                  :key="i"
                >
                  <feather-icon
                    v-if="detail.operand === 'tambah'"
                    icon="PlusIcon"
                    class="cursor-pointer"
                    :class="`text-success`"
                    size="15"
                  />
                  <feather-icon
                    v-if="detail.operand === 'kurang'"
                    icon="MinusIcon"
                    class="cursor-pointer"
                    :class="`text-danger`"
                    size="15"
                  /> {{ detail.device_name }}
                </p>
              </b-col>

              <b-col
                v-if="productsOnSale(data.item.id_tag).length > 20"
                class="text-nowrap"
              >
                <p
                  v-for="(detail, i) in productsOnSale(data.item.id_tag)"
                  v-if="detail.id_tag === data.item.id_tag && i > 19 && i <25"
                  :key="i"
                >
                  <feather-icon
                    v-if="detail.operand === 'tambah'"
                    icon="PlusIcon"
                    class="cursor-pointer"
                    :class="`text-success`"
                    size="15"
                  />
                  <feather-icon
                    v-if="detail.operand === 'kurang'"
                    icon="MinusIcon"
                    class="cursor-pointer"
                    :class="`text-danger`"
                    size="15"
                  /> {{ detail.device_name }}
                </p>
              </b-col>

              <b-col
                v-if="productsOnSale(data.item.id_tag).length > 25"
                class="text-nowrap"
              >
                <p
                  v-for="(detail, i) in productsOnSale(data.item.id_tag)"
                  v-if="detail.id_tag === data.item.id_tag && i > 24 && i <30"
                  :key="i"
                >
                  <feather-icon
                    v-if="detail.operand === 'tambah'"
                    icon="PlusIcon"
                    class="cursor-pointer"
                    :class="`text-success`"
                    size="15"
                  />
                  <feather-icon
                    v-if="detail.operand === 'kurang'"
                    icon="MinusIcon"
                    class="cursor-pointer"
                    :class="`text-danger`"
                    size="15"
                  /> {{ detail.device_name }}
                </p>
              </b-col>

              <b-col
                v-if="productsOnSale(data.item.id_tag).length > 30"
                class="text-nowrap"
              >
                <p
                  v-for="(detail, i) in productsOnSale(data.item.id_tag)"
                  v-if="detail.id_tag === data.item.id_tag && i > 29 && i < 35"
                  :key="i"
                >
                  <feather-icon
                    v-if="detail.operand === 'tambah'"
                    icon="PlusIcon"
                    class="cursor-pointer"
                    :class="`text-success`"
                    size="15"
                  />
                  <feather-icon
                    v-if="detail.operand === 'kurang'"
                    icon="MinusIcon"
                    class="cursor-pointer"
                    :class="`text-danger`"
                    size="15"
                  /> {{ detail.device_name }}
                </p>
              </b-col>

              <b-col
                v-if="productsOnSale(data.item.id_tag).length > 35"
                class="text-nowrap"
              >
                <p
                  v-for="(detail, i) in productsOnSale(data.item.id_tag)"
                  v-if="detail.id_tag === data.item.id_tag && i > 34 && i < 40"
                  :key="i"
                >
                  <feather-icon
                    v-if="detail.operand === 'tambah'"
                    icon="PlusIcon"
                    class="cursor-pointer"
                    :class="`text-success`"
                    size="15"
                  />
                  <feather-icon
                    v-if="detail.operand === 'kurang'"
                    icon="MinusIcon"
                    class="cursor-pointer"
                    :class="`text-danger`"
                    size="15"
                  /> {{ detail.device_name }}
                </p>
              </b-col>

              <b-col
                v-if="productsOnSale(data.item.id_tag).length > 40"
                class="text-nowrap"
              >
                <p
                  v-for="(detail, i) in productsOnSale(data.item.id_tag)"
                  v-if="detail.id_tag === data.item.id_tag && i > 39 && i < 45"
                  :key="i"
                >
                  <feather-icon
                    v-if="detail.operand === 'tambah'"
                    icon="PlusIcon"
                    class="cursor-pointer"
                    :class="`text-success`"
                    size="15"
                  />
                  <feather-icon
                    v-if="detail.operand === 'kurang'"
                    icon="MinusIcon"
                    class="cursor-pointer"
                    :class="`text-danger`"
                    size="15"
                  /> {{ detail.device_name }}
                </p>
              </b-col>

              <b-col
                v-if="productsOnSale(data.item.id_tag).length > 45"
                class="text-nowrap"
              >
                <p
                  v-for="(detail, i) in productsOnSale(data.item.id_tag)"
                  v-if="detail.id_tag === data.item.id_tag && i > 44 && i < 50"
                  :key="i"
                >
                  <feather-icon
                    v-if="detail.operand === 'tambah'"
                    icon="PlusIcon"
                    class="cursor-pointer"
                    :class="`text-success`"
                    size="15"
                  />
                  <feather-icon
                    v-if="detail.operand === 'kurang'"
                    icon="MinusIcon"
                    class="cursor-pointer"
                    :class="`text-danger`"
                    size="15"
                  /> {{ detail.device_name }}
                </p>
              </b-col>

              <b-col
                v-if="productsOnSale(data.item.id_tag).length > 50"
                class="text-nowrap"
              >
                <p
                  v-for="(detail, i) in productsOnSale(data.item.id_tag)"
                  v-if="detail.id_tag === data.item.id_tag && i > 49 && i < 55"
                  :key="i"
                >
                  <feather-icon
                    v-if="detail.operand === 'tambah'"
                    icon="PlusIcon"
                    class="cursor-pointer"
                    :class="`text-success`"
                    size="15"
                  />
                  <feather-icon
                    v-if="detail.operand === 'kurang'"
                    icon="MinusIcon"
                    class="cursor-pointer"
                    :class="`text-danger`"
                    size="15"
                  /> {{ detail.device_name }}
                </p>
              </b-col>

              <b-col
                v-if="productsOnSale(data.item.id_tag).length > 55"
                class="text-nowrap"
              >
                <p
                  v-for="(detail, i) in productsOnSale(data.item.id_tag)"
                  v-if="detail.id_tag === data.item.id_tag && i > 54 && i < 60"
                  :key="i"
                >
                  <feather-icon
                    v-if="detail.operand === 'tambah'"
                    icon="PlusIcon"
                    class="cursor-pointer"
                    :class="`text-success`"
                    size="15"
                  />
                  <feather-icon
                    v-if="detail.operand === 'kurang'"
                    icon="MinusIcon"
                    class="cursor-pointer"
                    :class="`text-danger`"
                    size="15"
                  /> {{ detail.device_name }}
                </p>
              </b-col>

              <b-col
                v-if="productsOnSale(data.item.id_tag).length > 60"
                class="text-nowrap"
              >
                <p
                  v-for="(detail, i) in productsOnSale(data.item.id_tag)"
                  v-if="detail.id_tag === data.item.id_tag && i > 59 && i < 65"
                  :key="i"
                >
                  <feather-icon
                    v-if="detail.operand === 'tambah'"
                    icon="PlusIcon"
                    class="cursor-pointer"
                    :class="`text-success`"
                    size="15"
                  />
                  <feather-icon
                    v-if="detail.operand === 'kurang'"
                    icon="MinusIcon"
                    class="cursor-pointer"
                    :class="`text-danger`"
                    size="15"
                  /> {{ detail.device_name }}
                </p>
              </b-col>

              <b-col
                v-if="productsOnSale(data.item.id_tag).length > 65"
                class="text-nowrap"
              >
                <p
                  v-for="(detail, i) in productsOnSale(data.item.id_tag)"
                  v-if="detail.id_tag === data.item.id_tag && i > 64 && i < 70"
                  :key="i"
                >
                  <feather-icon
                    v-if="detail.operand === 'tambah'"
                    icon="PlusIcon"
                    class="cursor-pointer"
                    :class="`text-success`"
                    size="15"
                  />
                  <feather-icon
                    v-if="detail.operand === 'kurang'"
                    icon="MinusIcon"
                    class="cursor-pointer"
                    :class="`text-danger`"
                    size="15"
                  /> {{ detail.device_name }}
                </p>
              </b-col>

            </b-row>
          </b-card>
        </template>

        <template #cell(actions)="data">
          <div
            class="text-nowrap"
          >
            <div style="line-height:80%;">
              <br>
            </div>
            <feather-icon
              :id="`invoice-row-${data.item.tag_name}-send-icon`"
              icon="EditIcon"
              class="cursor-pointer"
              :class="`text-primary`"
              size="17"
              @click="EditData(data.item)"
            />
            <b-tooltip
              :title="`Edit ${data.item.tag_name}`"
              class="cursor-pointer"
              :target="`invoice-row-${data.item.tag_name}-send-icon`"
            />
&nbsp;
            <feather-icon
              :id="`invoice-row2-${data.item.tag_name}-send-icon`"
              icon="Trash2Icon"
              class="cursor-pointer"
              :class="`text-danger`"
              size="17"
              @click="showMsgBoxTwo(data.item.id_tag)"
            />
            <b-tooltip
              :title="`Delete ${data.item.tag_name}`"
              class="cursor-pointer"
              :target="`invoice-row2-${data.item.tag_name}-send-icon`"
            />
          </div>
          <div style="line-height:80%;">
            <br>
          </div>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalData"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BPagination, BTooltip, BSpinner,
  // BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onMounted, onUnmounted } from '@vue/composition-api'
// eslint-disable-next-line import/no-cycle
import { avatarText } from '@core/utils/filter'
import Ripple from 'vue-ripple-directive'
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import useAppConfig from '@core/app-config/useAppConfig'
import ListFilters from './ListFilters.vue'
// eslint-disable-next-line import/no-cycle
import useList from './useList'
import StoreModule from '../StoreModule'
import AddNew from './AddNew.vue'

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    ListFilters,
    AddNew,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BSpinner,
    // BDropdown,
    // BDropdownItem,
    BTooltip,
    BPagination,

    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      isBusy: false,
    }
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = 'app-user'
    const { AxiosUrl } = useAppConfig()

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, StoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const blankTask = {
      tag_name: '',
      id_dev: '',
      defaultt: '1',
      target: '',
      tambah: '',
      // tambah: ['7','8'],
      kurang: '',
      id_tag: '',
      action: 'Add',
    }

    const isAddNewUserSidebarActive = ref(false)
    const userData = ref(JSON.parse(JSON.stringify(blankTask)))

    const roleOptions = ref([])
    const tagDetails = ref([])

    onMounted(async () => {
      const result = await axios.get(`${AxiosUrl}api_mes/tag-setting-detail/view`)
      const dataAPI = result.data.data
      const combo = []
      // eslint-disable-next-line no-plusplus
      for (let i = 0, len = dataAPI.length; i < len; i++) {
        combo.push({ label: `${dataAPI[i].operand} - ${dataAPI[i].device_name}`, value: dataAPI[i].device_name })
      }
      roleOptions.value = combo
      tagDetails.value = result.data.data
    })

    const EditData = taskData => {
      userData.value = taskData
      isAddNewUserSidebarActive.value = true
    }

    const AddData = () => {
      blankTask.tag_name = '',
      blankTask.id_dev = '',
      blankTask.defaultt = '1',
      blankTask.target = '',
      blankTask.tambah = '',
      blankTask.kurang = '',
      blankTask.id_tag = '',
      userData.value = blankTask
      isAddNewUserSidebarActive.value = true
    }

    const refreshDetail = (async () => {
      const result = await axios.get(`${AxiosUrl}api_mes/tag-setting-detail/view`)
      const dataAPI = result.data.data
      const combo = []
      // eslint-disable-next-line no-plusplus
      for (let i = 0, len = dataAPI.length; i < len; i++) {
        combo.push({ label: `${dataAPI[i].operand} - ${dataAPI[i].device_name}`, value: dataAPI[i].device_name })
      }
      roleOptions.value = combo
      tagDetails.value = result.data.data
    })

    const {
      fetchData,
      tableColumns,
      perPage,
      currentPage,
      totalData,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    } = useList()

    return {
      userData,
      AddData,
      refreshDetail,
      EditData,
      // Sidebar
      isAddNewUserSidebarActive,

      fetchData,
      tableColumns,
      perPage,
      currentPage,
      totalData,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      roleOptions,
      tagDetails,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    }
  },
  methods: {
    productsOnSale(idtag) {
      return this.tagDetails.filter(
        tagDetail => tagDetail.id_tag === idtag,
      )
      // this.myArray.sort((a, b) => a.id.localeCompare(b.stringProp))
    },
    async showMsgBoxTwo(id) {
      this.boxTwo = id
      this.$bvModal
        .msgBoxConfirm('Are You Sure To Delete This Data?', {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: true,
          centered: true,
        })
        .then(async value => {
          this.boxTwo = value
          if (value === true) {
            const params = new URLSearchParams()
            params.append('param', 'delete')
            params.append('id_tag', id)
            const result = await axios.post(`${useAppConfig().AxiosUrl}api_mes/tag-setting/delete`, params)
            console.log(result)
            if (result.data.message === 'Data Deleted') {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Notification',
                  icon: 'BellIcon',
                  text: result.data.message,
                  variant: 'success',
                },
              })
              this.refetchData()
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Error',
                  icon: 'BellIcon',
                  text: 'Error Deleting Data',
                  variant: 'danger',
                },
              })
              // console.log(result)
            }
          }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
